import { Fetcher } from "@/utils/fetcher";

const cart = new Fetcher('cart');

/**
* Add to cart
* @params {AddToCartRequest} data { skuId: number, quantity: number}
* @author Azher Uddin <https://github.com/AzherUddin617>
* @date 2023-10-17 09:54:22
*/
export const addToCart = (data: AddToCartRequest): Promise<CartItem> => {
    return cart.post('', data);
}

/**
* Get cart list
* 
* @author Azher Uddin <https://github.com/AzherUddin617>
* @date 2023-10-17 09:54:48
*/
export const getCartList = (): Promise<CartItem []> => {
    return cart.get('');
}

/**
* Update cart item
* @params {number} id cart item id
* @params {number} quantity cart item quantity
* @author Azher Uddin <https://github.com/AzherUddin617>
* @date 2023-10-17 09:55:11
*/
export const updateCartItem = ({ id, quantity, status }: UpdateCartItemRequest): Promise<CartItem> => {
    return cart.patch(`/${id}`, { quantity, status });
}

/**
* Delete cart item
* @params {number} id cart item id to delete
* @author Azher Uddin <https://github.com/AzherUddin617>
* @date 2023-10-17 09:56:15
*/
export const deleteCartItem = (id: number): Promise<CartItem> => {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await cart.delete<CartItem>(`/${id}`);
            resolve({ ...res, id, quantity: 0 });
        } catch (error) {
            reject(error);
        }
    })
}